import EventEmitter from "events";

class MiscService extends EventEmitter {
}
export default new MiscService();